import { createBrowserRouter, Navigate } from 'react-router-dom'
import App from '../App'
import { lazyRetry } from '@/utils/lazy-retry'
import { RoutePath } from '@/routes/paths'
import { Fallback404 } from '@/routes/Fallback404'
import RedirectWithQuery from '@/routes/RedirectWithQuery'

const Main = lazyRetry(() => import('@/pages/main'))
const Driving = lazyRetry(() => import('@/pages/driving'))
const DrivingAnalysis = lazyRetry(() => import('@/pages/driving/analysis'))
const DrivingAnalysisPlace = lazyRetry(() => import('@/pages/driving/analysis/place'))
const DrivingVehicle = lazyRetry(() => import('@/pages/driving/vehicle'))
const DrivingVehicleDetail = lazyRetry(() => import('@/pages/driving/vehicle/detail'))
const DrivingVehicleSetting = lazyRetry(() => import('@/pages/driving/vehicle/setting'))
const DrivingVehicleUnpaidToll = lazyRetry(() => import('@/pages/driving/vehicle/unpaid-toll'))
const DrivingVehicleUnpaidTollBridge = lazyRetry(() => import('@/pages/driving/vehicle/unpaid-toll/bridge'))
const DrivingVehicleUnpaidTollResult = lazyRetry(() => import('@/pages/driving/vehicle/unpaid-toll/result'))
const DrivingInsuranceTab = lazyRetry(() => import('@/pages/driving/benefit'))
const History = lazyRetry(() => import('@/pages/history'))
const HistoryDetail = lazyRetry(() => import('@/pages/history/detail'))
const BenefitHome = lazyRetry(() => import('@/pages/benefit/home'))
const BenefitList = lazyRetry(() => import('@/pages/benefit/list'))
const BenefitDetail = lazyRetry(() => import('@/pages/benefit/detail'))
const BenefitPoint = lazyRetry(() => import('@/pages/benefit/point'))
const InsuranceDrivingIntro = lazyRetry(() => import('@/pages/insurance/driver'))
const InsuranceDrivingResult = lazyRetry(() => import('@/pages/insurance/driver/result'))
const InsuranceDrivingHistory = lazyRetry(() => import('@/pages/insurance/driver/history'))
const InsuranceDrivingHistoryDetail = lazyRetry(() => import('@/pages/insurance/driver/history-detail'))
const LicensePenaltyIntro = lazyRetry(() => import('@/pages/penalty'))
const LicensePenaltyInput = lazyRetry(() => import('@/pages/penalty/input'))
const LicensePenaltyResult = lazyRetry(() => import('@/pages/penalty/result'))
const Settings = lazyRetry(() => import('@/pages/settings'))
const SettingsOtp = lazyRetry(() => import('@/pages/settings/otp'))
const SettingsTermsWithdrawal = lazyRetry(() => import('@/pages/settings/withdrawal'))
const EtcTerms = lazyRetry(() => import('@/pages/etc/terms'))
const EtcInsurerContact = lazyRetry(() => import('@/pages/etc/contact'))
const EtcEmergencyCall = lazyRetry(() => import('@/pages/etc/emergency'))

const isPrd = import.meta.env.VITE_BUILD_ENV === 'PRD'
const basename = `${(import.meta.env.VITE_URL || '')}`

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <App isPrd={isPrd} />,
      errorElement: <Fallback404 />,
      children: [
        // 루트 접근시 /web로
        { index: true, element: <Navigate to={RoutePath.Home} replace /> },

        // /web 아래 실제 라우트
        { path: RoutePath.Home, element: <Main /> },
        {
          path: RoutePath.Analysis, element: <Driving />,
          children: [{ index: true, element: <DrivingAnalysis /> }],
        },
        {
          path: RoutePath.Vehicle, element: <Driving />,
          children: [{ index: true, element: <DrivingVehicle /> }],
        },
        {
          path: RoutePath.Insurance_tab, element: <Driving />,
          children: [{ index: true, element: <DrivingInsuranceTab /> }],
        },
        { path: RoutePath.Analysis_place, element: <DrivingAnalysisPlace /> },
        { path: RoutePath.Vehicle_detail, element: <DrivingVehicleDetail /> },
        { path: RoutePath.Vehicle_setting, element: <DrivingVehicleSetting /> },
        { path: RoutePath.Vehicle_unpaid_toll, element: <DrivingVehicleUnpaidToll /> },
        { path: RoutePath.Vehicle_unpaid_toll_bridge, element: <DrivingVehicleUnpaidTollBridge /> },
        { path: RoutePath.Vehicle_unpaid_toll_result, element: <DrivingVehicleUnpaidTollResult /> },

        { path: RoutePath.History, element: <History /> },
        { path: RoutePath.History_detail, element: <HistoryDetail /> },

        { path: RoutePath.Benefit_popular, element: <RedirectWithQuery to={RoutePath.Benefit_home} /> }, //레거시 리다이렉트

        { path: RoutePath.Benefit_home, element: <BenefitHome /> },
        { path: RoutePath.Benefit_list, element: <BenefitList /> },
        { path: RoutePath.Benefit_detail, element: <BenefitDetail /> },
        { path: RoutePath.Benefit_point, element: <BenefitPoint /> },

        { path: RoutePath.Insurance_driver, element: <InsuranceDrivingIntro /> },
        { path: RoutePath.Insurance_driver_result, element: <InsuranceDrivingResult /> },
        { path: RoutePath.Insurance_driver_history, element: <InsuranceDrivingHistory /> },
        { path: RoutePath.Insurance_driver_history_detail, element: <InsuranceDrivingHistoryDetail /> },

        { path: RoutePath.License_penalty, element: <LicensePenaltyIntro /> },
        { path: RoutePath.License_penalty_input, element: <LicensePenaltyInput /> },
        { path: RoutePath.License_penalty_result, element: <LicensePenaltyResult /> },

        { path: RoutePath.Settings, element: <Settings /> },
        { path: RoutePath.Settings_otp, element: <SettingsOtp /> },
        { path: RoutePath.Settings_withdrawal, element: <SettingsTermsWithdrawal /> },

        { path: RoutePath.Etc_terms, element: <EtcTerms /> },
        { path: RoutePath.Etc_insurer_contact, element: <EtcInsurerContact /> },
        { path: RoutePath.Etc_emergency_call, element: <EtcEmergencyCall /> },
      ],
    },
  ],
  { basename },
)
